import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import {
  Container,
  // Label,
  Input,
  Modal,
  // ModalHeader,
  ModalBody,
  // ModalFooter,
  FormGroup,
} from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { format } from "date-fns";
// import { Loading } from "../../share/loading";
import { Formik, Field, Form } from "formik";
import "../../share/form.css";

export function ChangeBorrowCheckComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  // console.log(user);
  let borrowId = searchParams.get("req");
  const [loading, setLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggleExtendCourse = () => setOpenModalForm(!openModalForm);
  const [remarkPromotionValue, setRemarkPromotionValue] = useState("");
  // const [data, setData] = useState([]);
  const [databorrowDetails, setborrowDetailsData] = useState([]);
  const [dataclassDetails, setclassDetailsData] = useState([]);
  const [datatestDetails, settestDetailsData] = useState([]);

  useEffect(() => {
    getCheckBorrow();
  }, []);

  async function getCheckBorrow() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", borrowId);
    try {
      let res = await fetch("/api/Borrow/getTrainCourseDetail", {
        method: "POST",
        body: postData,
      });
      const data = await res.json();
      // console.log(data.dataenum);
      // setData(data.dataenum);
      setborrowDetailsData(data.dataenum.getborrowDetails);
      setclassDetailsData(data.dataenum.getclassDetails);
      settestDetailsData(data.dataenum.gettestDetails);
    } catch (e) {
      // console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  const formPromotionInitialValues = {
    // RemarkOfficer: remarkPromotionValue,
    TrainNewStatus: remarkPromotionValue != "" ? "13" : "18",
    TestNewStatus: remarkPromotionValue != "" ? "13" : "18",
    TrainNewStatus: dataclassDetails[0]?.trainnewclassId != null ? "18" : "13",
    TestNewStatus: datatestDetails[0]?.testnewId != null ? "18" : "13",
    trainNewClassId: dataclassDetails[0]?.trainnewclassId,
    testNewClassId: datatestDetails[0]?.testnewId,
    // TrainNewStatus: "20" ,
    borrowId: searchParams.get("req"),
  };

  const formRejectInitialValues = {
    RemarkOfficer: "",
    TrainNewStatus: "13",
    TestNewStatus : "13",
    trainNewClassId: dataclassDetails[0]?.trainnewclassId,
    testNewClassId: datatestDetails[0]?.testnewId,
    borrowId: searchParams.get("req"),
  };



  const validatePromotionSchema = Yup.object().shape({});
  const validateRejectSchema = Yup.object().shape({});

  const promotionSubmit = async (values, setFieldValue) => {
    // console.log(values);

    try {
      let res = await fetch("api/Borrow/approveOrRejectChange", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values),
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      // console.log(e);
    }
  };
  const RejectSubmit = async (values, setFieldValue) => {
    // console.log(values);

    try {
      let res = await fetch("api/Borrow/approveOrRejectChange", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values),
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      // console.log(e);
    }
  };

  return (
    <Formik
      initialValues={formPromotionInitialValues}
      validationSchema={validatePromotionSchema}
      onSubmit={promotionSubmit}
      enableReinitialize
    >
      {({
        values,
        handleChange,
        handleBlur,
        setFieldTouched,
        errors,
        handleSubmit,
        setFieldValue,
      }) => {
        function rejectButtonPromotionClick() {
          Swal.fire({
            title: "",
            text: "กรุณากรอกความคิดเห็น",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            input: "text",
            inputValue: remarkPromotionValue,
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
            inputValidator: (value) => {
              if (!value) {
                return "กรุณากรอกความคิดเห็น";
              }
            },
          }).then((result) => {
            if (result.value) {
              // console.log("value1", result.value);
              setRemarkPromotionValue(result.value);
              // setFieldValue("TrainNewStatus", "21");
              promotionSubmit(values);
            }
          });
        }
        return (
          <>
            <Form onSubmit={handleSubmit}>
              <Container className="d-flex flex-column justify-content-center align-items-center">
                <p
                  className="text-center py-2 text-white"
                  style={{
                    backgroundColor: "#0A66C2",
                    width: "100%",
                    maxWidth: "850px",
                  }}
                >
                  ข้อมูลคำขอการเปลี่ยนแปลงหลักสูตรการฝึกอบรมหรือทดสอบ
                </p>
                {/* รายละเอียดย่อย */}
                <div className="form-border">

                  {dataclassDetails[0]?.traincoursenewName != null ?
                    <>
                      <div className="d-flex flex-column">
                        <div className="px-5 mt-5 d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <span className="py-1 mx-1 type-register">
                              เลขที่สัญญา
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {databorrowDetails[0]?.contactNo
                                ? databorrowDetails[0]?.contactNo
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อผู้ขอกู้ยืม
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {databorrowDetails[0]?.borrowName
                                ? databorrowDetails[0]?.borrowName
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อหลักสูตร (เก่า)
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {dataclassDetails[0]?.traincoursename
                                ? dataclassDetails[0]?.traincoursename
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อหลักสูตร (ใหม่)
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {dataclassDetails[0]?.traincoursenewName
                                ? dataclassDetails[0]?.traincoursenewName
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>

                    </>

                    : null}

                  {datatestDetails[0]?.testnewId != null ?
                    <>
                      <div className="d-flex flex-column">
                        <div className="px-5 mt-5 d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center w-100">
                            <span className="py-1 mx-1 type-register">
                              เลขที่สัญญา
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {databorrowDetails[0]?.contactNo
                                ? databorrowDetails[0]?.contactNo
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อผู้ขอกู้ยืม
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {databorrowDetails[0]?.borrowName
                                ? databorrowDetails[0]?.borrowName
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อสาขา (เก่า)
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {datatestDetails[0]?.oldlawocupationName
                                ? datatestDetails[0]?.oldlawocupationName
                                : "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-3 w-100">
                            <span className="py-1 mx-1 type-register">
                              ชื่อสาขา (ใหม่)
                            </span>
                            <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1 w-75 text-center">
                              {datatestDetails[0]?.newlawocupationName
                                ? datatestDetails[0]?.newlawocupationName
                                : "-"}
                            </span>
                          </div>
                        </div>
                      </div>

                    </>

                    : null}



                  {user.roldId === "3" ? (
                    <div className="w-100 p-3 mt-5 d-flex align-items-center justify-content-evenly">
                      <button type="submit" className="btn-green w-25">
                        อนุมัติ
                      </button>

                      <button
                        type="button"
                        onClick={modalToggleExtendCourse}
                        className="btn-red w-25"
                      >
                        ไม่อนุมัติ
                      </button>

                      <Formik
                        initialValues={formRejectInitialValues}
                        validationSchema={validateRejectSchema}
                        onSubmit={RejectSubmit}
                        enableReinitialize
                      >
                        {({
                          values,
                          handleChange,
                          handleBlur,
                          setFieldValue,
                          setValues,
                          errors,
                          touched,
                          resetForm,
                        }) => {
                          return (
                            <Modal
                              isOpen={openModalForm}
                              toggle={modalToggleExtendCourse}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              className="modal-bordered"
                            >
                              <ModalBody>
                                <div className="d-flex flex-column">
                                  <Form autoComplete="off">
                                    <Field
                                      name={`RemarkOfficer`}
                                      type="text"
                                      style={{ display: "none" }}
                                      disabled={true}
                                    ></Field>
                                    <FormGroup>
                                      <div className="mt-3">
                                        <span>กรุณากรอกความคิดเห็น</span>
                                        <Field name={`RemarkOfficer`}>
                                          {({ field, meta }) => (
                                            <Input
                                              className={
                                                meta.error && meta.touched
                                                  ? "input-error rounded-pill text-center input-color"
                                                  : "rounded-pill text-center input-color"
                                              }
                                              {...field}
                                            />
                                          )}
                                        </Field>
                                      </div>

                                      <div className="mt-4 d-flex align-items-center justify-content-between w-100">
                                        <button
                                          type="submit"
                                          className="btn-green w-25"
                                        >
                                          บันทึก
                                        </button>
                                        <button
                                          type="button"
                                          onClick={modalToggleExtendCourse}
                                          className="btn-red w-25 "
                                        >
                                          ยกเลิก
                                        </button>

                                      </div>
                                    </FormGroup>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          );
                        }}
                      </Formik>
                    </div>

                  ) : (
                    <div className="w-100 p-3 mt-5 d-flex align-items-center justify-content-evenly">
                      <button type="submit" className="btn-green w-25">
                        เห็นควรอนุมัติ
                      </button>

                      <button
                        type="button"
                        onClick={modalToggleExtendCourse}
                        className="btn-red w-25"
                      >
                        ไม่เห็นควรอนุมัติ
                      </button>

                      <Formik
                        initialValues={formRejectInitialValues}
                        validationSchema={validateRejectSchema}
                        onSubmit={RejectSubmit}
                        enableReinitialize
                      >
                        {({
                          values,
                          handleChange,
                          handleBlur,
                          setFieldValue,
                          setValues,
                          errors,
                          touched,
                          resetForm,
                        }) => {
                          return (
                            <Modal
                              isOpen={openModalForm}
                              toggle={modalToggleExtendCourse}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              className="modal-bordered"
                            >
                              <ModalBody>
                                <div className="d-flex flex-column">
                                  <Form autoComplete="off">
                                    <Field
                                      name={`RemarkOfficer`}
                                      type="text"
                                      style={{ display: "none" }}
                                      disabled={true}
                                    ></Field>
                                    <FormGroup>
                                      <div className="mt-3">
                                        <span>กรุณากรอกความคิดเห็น</span>
                                        <Field name={`RemarkOfficer`}>
                                          {({ field, meta }) => (
                                            <Input
                                              className={
                                                meta.error && meta.touched
                                                  ? "input-error rounded-pill text-center input-color"
                                                  : "rounded-pill text-center input-color"
                                              }
                                              {...field}
                                            />
                                          )}
                                        </Field>
                                      </div>

                                      <div className="mt-4 d-flex align-items-center justify-content-between w-100">
                                        <button
                                          type="submit"
                                          className="btn-green w-25"
                                        >
                                          บันทึก
                                        </button>
                                        <button
                                          type="button"
                                          onClick={modalToggleExtendCourse}
                                          className="btn-red w-25 "
                                        >
                                          ยกเลิก
                                        </button>

                                      </div>
                                    </FormGroup>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          );
                        }}
                      </Formik>
                    </div>
                  )}

                  <div className="d-flex align-items-center justify-content-center w-100 mt-3 mb-3">
                    <button onClick={() => {
                      navigate(
                        `/borrowing/`
                      );
                    }} className="btn-blue p-2 w-50">ย้อนกลับ</button>
                  </div>
                </div>
              </Container>
            </Form>
          </>
        );
      }}
    </Formik>
  );
}
